/* =================================================================
   br-contact-hero — image parallax.

   Re-implements the &Fold donor's IX2 action list a-104 in vanilla JS:
   as the band scrolls through the viewport, each tile image translates
   y −15% → 0% of its own height (the images are sized 120%×120% in CSS
   so the travel stays hidden inside the tile). The donor's smoothing
   (~50) becomes a small lerp toward the target each frame.

   The scroll range matches IX2 SCROLLING_IN_VIEW: 0% when the section's
   top enters the viewport bottom, 100% when its bottom leaves the
   viewport top. Because the hero sits at the top of the page its true
   −15% keyframe is never reached in practice — the visible travel is
   roughly −8.5% → 0%, exactly as in the donor.

   The mechanic lives in the shared br-motion-parallax utility; this
   file keeps only the section's wiring: progress is measured on the
   SECTION and both tile images share one lerp state (one item, two
   targets), with the donor's 0.01% settle threshold.

   Gated by prefers-reduced-motion, and degrades gracefully without JS:
   the images simply hold their centred position (no CSS transform).
   ================================================================= */
(function () {
  if (!window.brMotion || !window.brMotion.parallax) return;

  var items = [];
  document.querySelectorAll('.br-contact-hero').forEach(function (section) {
    var targets = [];
    section.querySelectorAll('.br-contact-hero__image').forEach(function (img) {
      targets.push(img);
    });
    if (targets.length) items.push({ measure: section, targets: targets });
  });
  if (!items.length) return;

  window.brMotion.parallax({
    items: items,
    epsilon: 0.01 /* settle threshold, % of image height */,
  });
})();
